import * as React from "react";

import { Button } from "@common/components/Atoms/Button";
import Showing from "@common/components/Atoms/Showing";
import Facets from "@common/components/Molecules/Facets";
import Pagination from "@common/components/Molecules/Pagination";
import SelectedFacets from "@common/components/Molecules/SelectedFacets";

/*===========================================================================
  Filtered List
/*======================================================================== */
interface FilteredListProps {
    children?: React.ReactNode;
}

export const FilteredList = (props: FilteredListProps) => (
    <div className="c-filtered-list">{props.children}</div>
);

/*===========================================================================
  Filtered List > Table View
/*======================================================================== */

interface FilteredListTableViewProps {
    data: any;
    isLargeScreen: boolean;
    locationSearchTerm?: string;
    onDistanceChange?: (value: any) => void;
    onFacetChange: (facet: any) => void;
    onPageChange: (pagenum: number) => void;
    responsive: boolean;
    searchRadiusInMiles?: number;
    children?: React.ReactNode;
}

export const FilteredListTableView = (props: FilteredListTableViewProps) => {
    const result = props.data; // the 'result' node from the api
    const visible = props.isLargeScreen;
    const hasFacets =
        result.facets &&
        (result.facets.length > 0 || result.selected_facets.length > 0);

    if (!props.responsive || (props.responsive && visible)) {
        return (
            <section className="c-filtered-list__view c-filtered-list__view--table">
                {hasFacets && (
                    <section className="c-filtered-list__filters">
                        <header className="c-filtered-list__header">
                            <div className="c-filtered-list__header-title">
                                filters
                            </div>
                        </header>

                        {result.selected_facets &&
                            result.selected_facets.length > 0 && (
                                <SelectedFacets
                                    data={result.selected_facets}
                                    onFacetChange={props.onFacetChange}
                                />
                            )}

                        <Facets
                            facets={result.facets}
                            onDistanceChange={props.onDistanceChange}
                            locationSearchTerm={props.locationSearchTerm}
                            searchRadiusInMiles={props.searchRadiusInMiles}
                            onFacetChange={props.onFacetChange}
                        />
                    </section>
                )}

                <section className="c-filtered-list__table">
                    <header className="c-filtered-list__header">
                        <div className="c-filtered-list__header-title">
                            <Showing
                                dataCy="filtered-jobs-count-component"
                                currentPage={result.current_page}
                                pageSize={result.page_size}
                                total={result.total}
                            />
                        </div>
                    </header>

                    {props.children}

                    <Pagination
                        currentPage={result.current_page}
                        pageSize={result.page_size}
                        total={result.total}
                        onPageChange={page =>
                            props.onPageChange(page.selected + 1)
                        }
                    />
                </section>
            </section>
        );
    }

    return null;
};

/*===========================================================================
  Filtered List > Cards View
/*======================================================================== */
interface FilteredListCardsViewProps {
    data: any;
    onFiltersButtonClick: () => void;
    onPageChange: (pagenum: number) => void;
    responsive?: boolean;
    sortDropdown: React.ReactNode;
    isLargeScreen?: boolean;
    children?: React.ReactNode;
}

export const FilteredListCardsView = (props: FilteredListCardsViewProps) => {
    const result = props.data;
    const visible = !props.isLargeScreen;

    if (!props.responsive || (props.responsive && visible)) {
        return (
            <section className="c-filtered-list__view c-filtered-list__view--cards">
                <header className="c-filtered-list__header">
                    <div className="c-filtered-list__header-title">
                        <Showing
                            currentPage={result.current_page}
                            pageSize={result.page_size}
                            total={result.total}
                        />
                    </div>
                    <div className="c-filtered-list__header-actions">
                        <Button
                            id="filteredListCardDropDown"
                            onClick={props.onFiltersButtonClick}
                        >
                            filters
                        </Button>
                        {props.sortDropdown}
                    </div>
                </header>

                <div className="c-filtered-list__cards">{props.children}</div>

                <Pagination
                    currentPage={result.current_page}
                    pageSize={result.page_size}
                    total={result.total}
                    onPageChange={page => props.onPageChange(page.selected + 1)}
                />
            </section>
        );
    }

    return null;
};

export default FilteredList;
